import ReactGA from 'react-ga';

let analyticsInitialized = false;

export const initAnalytics = () => {
  if (analyticsInitialized) {
    return;
  }

  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
  if (!trackingId) {
    console.warn('Google Analytics tracking ID not configured');
    return;
  }

  ReactGA.initialize(trackingId, {
    testMode: process.env.REACT_APP_GA_TEST_MODE,
  });

  analyticsInitialized = true;
};

export const isAnalyticsInitialized = () => analyticsInitialized;
